import React from 'react';
import { ApolloError } from '@apollo/client';
import { Box } from '@mui/material';

import { StatusChip } from '@occc/ui-design-system';
import getAudienceStatusVariant from '@occc-app/lib/getAudienceStatusVariant';
import { getStatusLabel } from '@occc-app/routes/Audience/utils';

import { Audience } from '../types';

interface AudienceNameProps {
  loading: boolean;
  name?: string;
  audience?: Audience;
  error?: ApolloError;
}
export const AudienceName: React.FC<AudienceNameProps> = ({ loading, name, error, audience }) => {
  if (error) {
    return null;
  }

  if (loading && !name && !audience?.status) {
    return <>Loading...</>;
  }

  if (!name) {
    return null;
  }

  const hasFixedDateRange = !!audience?.targetingAttributes.purchases.find(
    (item) => item.startDate && item.endDate,
  );

  return (
    <Box display='flex' alignItems='center'>
      <Box mr={1}>{name}</Box>
      <StatusChip
        label={getStatusLabel(audience?.status, audience?.hasBeenBackFilled, hasFixedDateRange)}
        variant={getAudienceStatusVariant(audience?.status)}
      />
    </Box>
  );
};
